import "./progress-bar.component.css";

export const progressBarComponent = {
    $name: 'progressBar',
    templateUrl: "admin/modules/shared/components/progress-bar/progress-bar.component.html",
};
